<template>
  <div>
    
    <v-progress-circular
    indeterminate
    color="primary"
    v-if="isSaving"
    ></v-progress-circular>
    
    <div v-else>
      <v-btn
      icon
      class="ma-2"
      @click="$refs.calendar.prev()"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn
      icon
      class="ma-2"
      @click="$refs.calendar.next()"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-calendar
      ref="calendar"
      locale="fi-fi"
      v-model="value"
      :events="items"
      event-name="data"
      event-start="date"
      @click:event="showCalEdit"
      ></v-calendar>
    </div>

    <v-dialog v-model="editDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
        <span class="headline">Muokkaa</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-btn color="red" dark @click="deleteItem(editData.id); editDialog = false">Poista</v-btn>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="editData.data" label="Ruokalista (data)"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editData.kasvis" label="Kasvislista" hint="Ei pakollinen"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="editData.salaatti"
                  label="Salaatti ja lisukkeet"
                  hint="Ei pakollinen"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="editData.alkupera" label="Alkuperä" hint="Ei pakollinen"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-date-picker
                v-model="editData.date"
                color="primary"
                locale="fi-fi"
                landscape
                full-width
                ></v-date-picker>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange" dark :loading="isSaving" @click="editDialog = false; editData = { ...editDataDefault }">Sulje tallentamatta</v-btn>
          <v-btn color="green darken-1" dark :loading="isSaving" @click="save(editData); editDialog = false">Tallenna ja sulje</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Sulje</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import store from "@/store"

//TODO: availLists apista!
export default {
  data () {
    let curDate = new Date();
    curDate = new Date(curDate.getTime() - (curDate.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];

    return {
      value: '',
      items: [],
      itemsLoading: false,
      editDataDefault: {
        data: '',
        date: curDate,
        alkupera: '',
        kasvis: '',
        salaatti: ''
      },
      editData: {
        data: '',
        date: curDate,
        alkupera: '',
        kasvis: '',
        salaatti: ''
      },
      snack: false,
      snackColor: '',
      snackText: '',
      max25chars: v => v.length <= 25 || 'Input too long!',
      pagination: {},
      isSaving: false,
      editDialog: false
    }
  },
  methods: {
    showCalEdit({ event }) {
      this.editDialog = true
      this.editData = { ...event }
    },
    save (val) {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data tallennettiin. Synkronoidaan palvelimelle, tarkasta status latausympyrästä'

      let form_data = Object.entries(val).map(([key, valu]) => `${key}=${valu}`).join('&');

      this.isSaving = true;

      axios.put('https://apiv4.kiuruvesi.net/list' + store.getters.placeid + '/admin/' + val.id,
      form_data,
      {
        headers: {
          "Authorization" : 'Bearer ' + store.getters.token,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .catch(function (e) {
        alert(e)
      })
      .finally(() => {
        this.isSaving = false;
        this.loadFromAPI();
      })

    },
    deleteItem (id) {
      if (!confirm('Oletko varma, että poistetaan?')) {
        return 0;
      }

      this.isSaving = true;
      axios.delete('https://apiv4.kiuruvesi.net/list' + store.getters.placeid + '/admin/' + id,
      {
        headers: {
          "Authorization" : 'Bearer ' + store.getters.token,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .catch(function (e) {
        alert(e)
      })
      .finally(() => {
        this.isSaving = false;
        this.loadFromAPI();
      })
    },
    loadFromAPI () {
      if (store.getters.placeid) {
        this.isSaving = true;
        this.items = [];
        axios.get('https://apiv4.kiuruvesi.net/list' + store.getters.placeid + '/admin',
        {
          headers: {
            "Authorization" : 'Bearer ' + store.getters.token,
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .then((response) => {
          response.data.forEach((item) => { this.items = [ ...this.items, item] });
        })
        .catch(function (e) {
          alert(e)
        })
        .finally(() => {
          this.isSaving = false;
        })
      }
    }
  },
  mounted() {
    this.loadFromAPI();
  }
}
</script>